export default "__VITE_ASSET__CcKVf2Oo__"